<template>
  <div class="gallery-pagination">
    <button :disabled="!canSelectPrev"
            @click="onPrevClick">
      <font-awesome-icon :icon="['fas', 'chevron-left']"></font-awesome-icon>
      Previous
    </button>
    <div class="gallery-pagination__pages">
      <span v-for="page in pageOptions"
            :key="page"
            class="gallery-pagination__page"
            :class="{'gallery-pagination__page--current': page === pageIndex}"
            @click="pageIndex = page">
        {{ page + 1 }}
      </span>
    </div>
    <button :disabled="!canSelectNext"
            @click="onNextClick">
      Next
      <font-awesome-icon :icon="['fas', 'chevron-right']"></font-awesome-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "GalleryPagination",
  props: {
    value: {
      type: Number,
      default: null
    },
    itemsPerPage: {
      type: Number,
      default: 0
    },
    itemsCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      pageIndex: 0
    };
  },
  computed: {
    pageOptions () {
      const result = [];

      const min = Math.max( 0, this.pageIndex - 3 );
      const max = Math.min( this.pageIndex + 4, this.maxPage );

      for ( let i = min; i < max; i += 1 ) {
        result.push( i );
      }

      return result;
    },
    maxPage () {
      return Math.ceil( this.itemsCount / this.itemsPerPage );
    },
    canSelectPrev () {
      return this.pageIndex - 1 >= 0;
    },
    canSelectNext () {
      return this.pageIndex + 1 < this.maxPage;
    }
  },
  watch: {
    value ( val ) {
      this.pageIndex = val;
    },
    pageIndex ( val ) {
      if ( val !== null ) {
        this.$emit( "input", val );
      }
    }
  },
  methods: {
    onPrevClick () {
      if ( this.canSelectPrev ) {
        this.pageIndex -= 1;
      }
    },
    onNextClick () {
      if ( this.canSelectNext ) {
        this.pageIndex += 1;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.gallery-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;

  &__pages {
    display: flex;
  }

  button {
    background: none;
    border: none;
    color: #026366;
    font-size: 14px;
    margin: 0 1rem;
    padding: 8px 12px;
    transition: color .2s ease-out;

    &:not(:disabled) {
      &:hover {
        color: darken(#026366, 15%);
      }
    }

    &:disabled{
      color: lighten(#026366, 10%);
      cursor: default;
    }

    &:focus {
      border: none;
      outline: none;
    }
  }

  &__page {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    color: #026366;
    font-size: 14px;
    transition: color .2s ease-out;
    user-select: none;

    &:hover {
      cursor: pointer;
      color: darken(#026366, 15%);
    }

    &--current {
      border: 1px solid #bbdbdd;
    }
  }
}
</style>
